import store from '../store'
import router from '../router'
import {CLEAR_AUTHENTICATION} from '../store/mutation-types'
import auth from '../api/auth/index'

export default {
  beforeRouteEnter (to, from, next) {
    auth.logout()
    store.commit(CLEAR_AUTHENTICATION)
    router.replace({name: 'Login'})
  }
}



// WEBPACK FOOTER //
// ./src/components/logout.js